module.exports = __webpack_public_path__ + "img/houtai_zuopshuju.5177193c.png";